import { Card, Form, Modal } from 'antd'
import styled from 'styled-components'

export const ModalEx = styled(Modal)`
  .ant-modal-header {
    background-color: #011628 !important;

    .ant-modal-title {
      color: white !important;
    }
  }
`

export const CardEx = styled(Card)`
  .ant-card-head {
    background: #6ebf4b;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 0 !important;
  }

  div > .ant-card-bordered {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`

export const FormItem = styled(Form.Item)`
  .ant-upload-select-picture-card {
    -ms-flex: auto;
    flex: auto;
    width: 100% !important;
  }
`

export const MaterialItem = styled.div`
  height: 30px;
  border: 1px solid #e3e7ed;
  cursor: pointer;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  margin: 2px;
  border-radius: 10px;
  padding: 10px;

  ${(props) =>
    props.active &&
    `
            background: #6ebf4b;
            border-color: #6ebf4b;
            color: #fff;
    `}

  ${(props) =>
    props.disabled &&
    `
            background: gray;
            border-color: gray;
            color: #fff;
            pointer-events: all !important;
            cursor: not-allowed !important;
    `}
`

export const SelectMaterialDiv = styled.div`
  cursor: pointer;
  padding: 35px;
  border: 1px solid #6ebf4b;
  border-radius: 50%;
`



// WEBPACK FOOTER //
// ./src/styles/shared.style.js